import React from 'react';

// Composants
import Title from '../../components/Title/Title';
import ContentText from '../../components/content/content-text.jsx';
import SimpleTitle from '../../components/Title/SimpleTitle';
import Content from '../../components/content/content';
import ContentSlider from '../../components/content/content-slider';
import Skills from '../../components/Projects/Skills.jsx';

// Contenus
import pgm from '../../assets/content/projets/pgm.json';


const PGM = () => {
    return (
        <div className='projet'>
            <div className="bloc">
                <Title title={pgm.title} variant={pgm.variant} />
                <ContentText content={pgm.description} />

                <div className='content'>
                    <SimpleTitle title="Ma démarche" variant="green" position="left" />
                    
                    <ContentSlider content={pgm.partie1} images={pgm.slider1} cote="left" />
                    <ContentSlider content={pgm.partie2} images={pgm.slider2} cote="right" />

                    <div className='content-text'>
                        <ContentText content={pgm.partie3} />
                    </div>

                    <ContentSlider content={pgm.partie4} images={pgm.slider3} cote="right" />
                </div>
            </div>

            <div className='skills bloc'>
                <SimpleTitle title="Technologies utilisées" variant="white" position="left" />
                <div className='skills-grid'>
                    {pgm.technologies.map((tech, index) => (
                        <Skills
                            key={index}
                            image={tech.image}
                            alt={tech.alt}
                            competence={tech.name}
                            centered={tech.bool}
                        />
                    ))}
                </div>
            </div>

            <div className='competences bloc'>
                <SimpleTitle
                    title="Compétences et apprentissages critiques mobilisés"
                    variant="purple"
                    position="left"
                />
                <Content
                    content={pgm.competences}
                    image={{thumb: pgm.imgcompetences,hd: pgm.imgcompetencesgrd}} alt={pgm.altcompetences} cote={"left"} width={pgm.widthcompetences} height={pgm.heightcompetences} title="Illustration des compétences"
                />
            </div>
        </div>
    );
};

export default PGM;
